import { LoginPayload, LoginResponse, LoginByEmailPayload, SocialLoginPayload, SocialLoginResponse } from './interfaces';
import { usePost } from '@selfserve/react-hooks';

import { apiEndpoints } from '@selfserve/react-utils';

export const useLoginRequest = () =>
  usePost<LoginPayload, LoginResponse>(apiEndpoints.login);

export const useLoginByEmailRequest = () =>
  usePost<LoginByEmailPayload, any>(apiEndpoints.loginByEmail);

export const useSocialLoginRequest = () =>
  usePost<SocialLoginPayload, SocialLoginResponse>(apiEndpoints.socialLogin);

export * from './interfaces';
export * from './schemas';
